if(document.getElementById("gallery") || document.getElementById("patreon-gallery-images")){
   const container = document.getElementById("gallery") || document.getElementById("patreon-gallery-images");
   const isPatreon = document.getElementById("patreon-gallery-images") != null;
   const modal = document.getElementById("gallery-modal");
   const modalImage = modal.getElementsByTagName("img")[0];
   const items = container.getElementsByTagName("figure");
   const filterContainer = document.getElementById("patreon-gallery-filter-buttons");

   modal.addEventListener("click", function(){
      modal.style.display = "none";
   });

   for(let n = 0; n < items.length; ++n){
      items[n].addEventListener("click", function(event){
         modalImage.src = event.currentTarget.getElementsByTagName("img")[0].src;
         modal.style.display = "flex";
      });
   }

   // Enforce image aspect ratio
   if(CSS.supports("aspect-ratio", "1") == false){
      let aspectRatio = 1.0;
      if(isPatreon){
         aspectRatio = 1.24;
      }
      let onResize = function(){
         for(let n = 0; n < items.length; ++n){
            if(items[n].clientWidth != items[n].clientHeight * aspectRatio){
               items[n].style.height = (items[n].clientWidth / aspectRatio) + "px";
            }
         }
      };
      onResize();
      window.addEventListener("resize", onResize);
   }

   // Series filter
   if(filterContainer && !pageLocked){
      let buttons = filterContainer.getElementsByTagName("div");

      for(let n = 0; n < buttons.length; ++n){
         let button = buttons[n];
         button.addEventListener("click", function(event){
            if(button.classList.contains("active")){
               return
            }

            filterImages(button.dataset["series"]);
         });
      }

      function filterImages(buttonSeries){
         for(let n = 0; n < buttons.length; ++n){
            if(buttons[n].dataset["series"] == buttonSeries){
               buttons[n].classList.add(["active"]);
            }else{
               buttons[n].classList.remove(["active"]);
            }
         }

         for(let n = 0; n < items.length; ++n){
            let figureSeries = items[n].dataset["series"];
            if(figureSeries == buttonSeries){
               items[n].style.setProperty("display", "flex");
            }else{
               items[n].style.setProperty("display", "none");
            }
         }
      }
   }
}
